import { AdminRouterProvider } from "./router";

export function App() {
  return <AdminRouterProvider />;
}
